import API from 'services/api';

const api = new API();
const API_URL = '/api/custom_ai_dimensions';

const fetchFromApi = (url, options = {}) => {
    const config = {
        method: options.method || 'GET',
        credentials: 'include',
    };

    if (options.body) {
        config.body = options.body;
    }

    return new Promise((resolve, reject) => {
        api.getJson(url, config)
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};

export const getCustomAIDimensions = () => fetchFromApi(API_URL);

export const updateCustomAIDimension = data => fetchFromApi(API_URL, { method: 'POST', body: data });

export const deleteCustomAIDimension = id => fetchFromApi(API_URL, { method: 'DELETE', body: { id } });

export const improveDescription = (description, displayName) =>
    fetchFromApi(`${API_URL}/improve_description`, {
        method: 'POST',
        body: { description, display_name: displayName },
    });

export const improveOptions = (options, displayName, description) =>
    fetchFromApi(`${API_URL}/improve_options`, {
        method: 'POST',
        body: { options, display_name: displayName, description },
    });

export const testAIDimension = dimensionConfig => {
    return new Promise((resolve, reject) => {
        api.getJson(`${API_URL}/playground`, {
            method: 'POST',
            credentials: 'include',
            body: dimensionConfig,
        })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};
